<template>
  <footer class="footer">
    <div style="margin-right: 33px;
    display: flex;
    justify-content: space-between;
    margin-left: 24px;" >
      <div class="copyright text-center">

        <span style="color: green;" v-if="$socket.connected">● Socket Online</span>
        <span style="color: red;" v-else>● Socket Offline</span>
      </div>
   
      <div class="copyright text-center">
      
        &copy; {{ new Date().getFullYear() }}
        <a href="http://realtec.com.br/" target="_blank" style="color: #ffffff"
          >Realtec</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.copyright{
  color: #fff!important;
}
</style>
